const searchWithItemsList = (library, items_list) => {
    switch(library) {
        case "robot":
            return searchWithRobotsList(items_list);

        case "station":
            return searchWithStationsList(items_list);

        case "addin":
            return searchWithAddinList(items_list);

        case "post":
            return searchWithPostList(items_list);
    }
};

const searchWithRobotsList = (robots_list) => {
    let search_input = document.getElementById("search-input") as HTMLInputElement;

    if (search_input.value.length > 0) {
        let search_robot_list = {}
        
        Object.entries(robots_list).map((entry) => {
            const [name, robot] = [entry[0], entry[1]];
            let merged_parameter = "";

            if (robot.hasOwnProperty("N"))
                merged_parameter += robot["N"].toLowerCase() + " ";
            if (robot.hasOwnProperty("T"))
                merged_parameter += robot["T"].toLowerCase() + " ";
            if (robot.hasOwnProperty("B"))
                merged_parameter += robot["B"].toLowerCase();

            const all_matched = search_input.value.toLowerCase().split(" ").every(
                word => merged_parameter.includes(word)
            )

            // if (merged_parameter.includes(search_input.value.toLowerCase()))
            if (all_matched)
                search_robot_list[name] = robot;
        });

        search_input.focus();
        search_input.setSelectionRange(0, search_input.value.length);

        return search_robot_list;
    }
};

const searchWithStationsList = (stations_list) => {
    let search_input = document.getElementById("search-input") as HTMLInputElement;

    if (search_input.value.length > 0) {
        let search_station_list = {}; 
        
        // stations_list.filter((station) => {
        Object.entries(stations_list).map((entry) => {
            const [name, station] = [entry[0], entry[1]];
            let merged_parameter = ""

            if(station.hasOwnProperty("N"))
                merged_parameter += station["N"].toLowerCase() + " "
            if(station.hasOwnProperty("B"))
                merged_parameter += station["B"].join(" ").toLowerCase() + " "
            if(station.hasOwnProperty("AP"))
                merged_parameter += station["AP"].join(" ").toLowerCase() + " "
            if(station.hasOwnProperty("T"))
                merged_parameter += station["T"].join(" ").toLowerCase() + " "
            if(station.hasOwnProperty("RT"))
                merged_parameter += station["RT"].join(" ").toLowerCase() + " "
            if(station.hasOwnProperty("RN"))
                merged_parameter += station["RN"].join(" ").toLowerCase() + " "
            if(station.hasOwnProperty("AN"))
                merged_parameter += station["AN"].join(" ").toLowerCase() + " "
            if(station.hasOwnProperty("MN"))
                merged_parameter += station["MN"].join(" ").toLowerCase() + " "
            if(station.hasOwnProperty("TN"))
                merged_parameter += station["TN"].join(" ").toLowerCase() + " "
            if(station.hasOwnProperty("ON"))
                merged_parameter += station["ON"].join(" ").toLowerCase() + " "
            if(station.hasOwnProperty("UN"))
                merged_parameter += station["UN"].join(" ").toLowerCase()

            const all_matched = search_input.value.toLowerCase().split(" ").every(
                word => merged_parameter.includes(word)
            )

            // if (merged_parameter.includes(search_input.value.toLowerCase()))
            if (all_matched)
                search_station_list[name] = station;
        });

        search_input.focus();
        search_input.setSelectionRange(0, search_input.value.length);

        return search_station_list;
    }
};

const searchWithAddinList = (addins_list) => {
    let search_input = document.getElementById("search-input") as HTMLInputElement;

    if(search_input.value.length > 0) {
        let search_addin_list = {}; 
        
        Object.entries(addins_list).map((entry) => {
            const [name, addin] = [entry[0], entry[1]];
            let merged_parameter = "";

            if(addin.hasOwnProperty("N"))
                merged_parameter += addin["N"].toLowerCase() + " "
            if(addin.hasOwnProperty("P"))
                merged_parameter += addin["P"].toLowerCase() + " "
            if(addin.hasOwnProperty("C"))
                merged_parameter += addin["C"].toLowerCase() + " "
            if(addin.hasOwnProperty("D"))
                merged_parameter += addin["D"].toLowerCase() + " "
            if(addin.hasOwnProperty("V"))
                merged_parameter += addin["V"].toLowerCase() + " "
            if(addin.hasOwnProperty("ID"))
                merged_parameter += addin["ID"].toLowerCase()

            const all_matched = search_input.value.toLowerCase().split(" ").every(
                word => merged_parameter.includes(word)
            )
            
            // if (merged_parameter.includes(search_input.value.toLowerCase()))
            if (all_matched)
                search_addin_list[name] = addin;
        })

        search_input.focus();
        search_input.setSelectionRange(0, search_input.value.length);

        return search_addin_list;
    }    
};

const searchWithPostList = (posts_list) => {
    let search_input = document.getElementById("search-input") as HTMLInputElement;

    if(search_input.value.length > 0) {
        let search_post_list = {}; 
        
        // posts_list.filter((post) => {
        Object.entries(posts_list).map((entry) => {
            const [name, post] = [entry[0], entry[1]];
            let merged_parameter = "";

            if(post.hasOwnProperty("N"))
                merged_parameter += post["N"].toLowerCase() + " ";
            if(post.hasOwnProperty("SC"))
                merged_parameter += post["SC"].toString().toLowerCase().replaceAll(",", " ") + " ";
            if(post.hasOwnProperty("EXT"))
                merged_parameter += post["EXT"].toLowerCase()

            const all_matched = search_input.value.toLowerCase().split(" ").every(
                word => merged_parameter.includes(word)
            )
            
            // if (merged_parameter.includes(search_input.value.toLowerCase()))
            if (all_matched)
                search_post_list[name] = post;
        });

        search_input.focus();
        search_input.setSelectionRange(0, search_input.value.length);

        return search_post_list;
    }
};

export const LibraryUtils = {
    searchWithItemsList,
}